import { ProductIdType } from '@adsk/alloy-provider';

import getProductTitle from './getProductTitle';
import { DEFAULT_TAB_TITLE } from '../consts';

type getRouteTitleType = {
  productId?: ProductIdType | null;
  toolTitle?: string;
  additionalInformation?: string;
};

export const getTabTitle = ({
  productId,
  toolTitle,
  additionalInformation,
}: getRouteTitleType = {}) => {
  const productTitle = productId && getProductTitle(productId);

  if (productId && !productTitle) {
    console.warn(
      `Translation for ${productId} is missing - add it on @alloy/exo-skeleton-react`,
    );
  }

  if (productTitle && toolTitle && additionalInformation) {
    return `${additionalInformation} - ${toolTitle} - ${productTitle}`;
  }

  if (productTitle) {
    if (toolTitle) {
      return `${toolTitle} - ${productTitle}`;
    }
    if (additionalInformation) {
      return `${additionalInformation} - ${productTitle}`;
    }
    return productTitle;
  }

  if (toolTitle) {
    if (additionalInformation) {
      return `${additionalInformation} - ${toolTitle}`;
    }
    return `${toolTitle}`;
  }

  if (additionalInformation) {
    return `${additionalInformation} - ${DEFAULT_TAB_TITLE}`;
  }

  return DEFAULT_TAB_TITLE;
};
